import apiClient from "./axiosInstanceReviews";

// export const fetchUsers = () => {
//   return axiosInstance.get('/users');
// };

export const createReview = async (reviewData) => {
  return await apiClient.post("/api/addreviews", reviewData);
};

export const getReview = async (params) => {
  return await apiClient.get(
    `/api/getreviews?reviewType=${params.reviewType}&productId=${params.productId}`
  );
};
